<template>
  <div>
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <DataGetter
      @dataAvailable="
        data => {
          appInfo = data?.metaData || {}
        }
      "
      contentId="appInfo"
    />
    <DataGetter
      @dataAvailable="
        data => {
          platformAccessSubscription = data?.metaData || {}
        }
      "
      contentId="platformAccessSubscription"
    />

    <EventListener
      :events="[
        'platform_access_subscription_payment_launched',
        'failed_to_launch_platform_access_subscription_payment',
        'transaction_url_available',
        'collection_finished_available',
        'iframe_closed',
      ]"
      @platform_access_subscription_payment_launched="onPaymentLaunched"
      @failed_to_launch_platform_access_subscription_payment="
        onPaymentFailedToLaunch
      "
      @transaction_url_available="onPaymentUrlAvailable"
      @collection_finished_available="onPaymentFinished"
      @iframe_closed="onIframeClosed"
    />
  </div>
</template>

<script>
import UserProperty from '@/components/user/UserProperty.vue'
import EventListener from '@/components/utils/EventListener.vue'
import DataGetter from '@/components/utils/DataGetter.vue'

export default {
  name: 'homeComponent',
  components: {
    UserProperty,
    EventListener,
    DataGetter,
  },
  data() {
    return {
      userData: {},
      subscription: {},
      kycData: {},
      eventsIds: [],
      appInfo: {},
      latestTransactionUrl: '',
      latestTransactionId: '',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    async startPayment() {
      const prompt = await window.choicePrompt({
        title: 'Choissisez comment payer.',
        options: [
          {
            title: 'Payer par mobile money',
            id: 'mobileMoney',
          },
          {
            title: 'Payer par carte bancaire',
            id: 'card',
          },
        ],
        formatDisplay: data => data?.title || '',
        successText: 'Payer',
      })
      if (!prompt.accepted || !prompt.data) return null
      // return prompt.data.name
      await new Promise(r => setTimeout(r, 500))
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent(
        'platform_access_subscription_payment_required',
        {
          paymentMethod: prompt.data.id,
        },
      )
      this.listenLaunchedTransaction = true
    },
    onPaymentLaunched() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement lancé',
        body: 'La paiement a été lancé. Veuillez patienter et confirmer',
      })
    },
    onPaymentFailedToLaunch() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement non lancé',
        body: "Echec d'initiation du paiement, veuillez réessayer.",
      })
    },
    onPaymentUrlAvailable({ url, id }) {
      if (!this.listenLaunchedTransaction) return
      console.log(id)
      this.listenLaunchedTransaction = false
      this.latestTransactionUrl = url
      this.latestTransactionId = id
      this.$Events.dispatchEvent('url_opening_required', {
        url: url,
        useIframe: true,
        iframeClasses: 'w-full h-full',
      })
    },
    onPaymentFinished({ id, status }) {
      console.log(id, this.latestTransactionId)
      if (id == this.latestTransactionId) {
        this.$Events.dispatchEvent('close_iframe')
        this.$Events.dispatchEvent('access_subscription_payment_done')
        this.latestTransactionId = ''
        this.latestTransactionUrl = ''
        if (status == 'success') {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Paiement réussi',
            body: 'Votre abonnement a réussi',
          })
        } else {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Echec du paiement',
            body: "Le paiement de votre abonnement n'a pas réussi, veuillez réessayer",
          })
        }
        setTimeout(() => {
          this.$router.push('/')
        }, 1000)
      }
    },
    onIframeClosed({ url }) {
      console.log('iframe closedd', url, this.latestTransactionUrl)
      if (url !== this.latestTransactionUrl) return
      this.latestTransactionId = ''
      this.latestTransactionUrl = ''
      this.listenLaunchedTransaction = false
    },
  },
  watch: {
    // subscription: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal) {
    //     if (!newVal.isActive) return
    //     this.$Events.dispatchEvent('toast_notification', {
    //       title: 'Vous êtes déjà passé pro',
    //       body: 'Profitez des avantages de Ekidiscount pro',
    //     })
    //     this.$router.push('/')
    //   },
    // },
  },
  computed: {},
}
</script>
